'use strict';

var window = require('window'),
    vendors = ['ms', 'moz', 'webkit', 'o'],
    i = vendors.length,
    _requestAnimationFrame = window.requestAnimationFrame;

function getRafPolyfill() {
    var polyfill,
        defaultFallbackTimeout = 15; //~60 FPS

    while (--i > -1 && !polyfill) {
        polyfill = window[vendors[i] + 'RequestAnimationFrame'];
    }

    if (!polyfill) {
        polyfill = function (callback) {
            return setTimeout(function () {
                callback();
            }, defaultFallbackTimeout);
        };
    }

    return polyfill;
}

if (!_requestAnimationFrame) {
    _requestAnimationFrame = getRafPolyfill();
}

function getThrottle(callback) {
    var done = true;

    return function throttle() {
        var args = arguments;

        if (done) {
            done = false;

            _requestAnimationFrame(function () {
                callback.apply({}, args);
                done = true;
            });
        }
    };
}

module.exports = getThrottle;
